import {
  Autocomplete,
  Box,
  Button,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  LinearProgress,
  TextField,
  Typography
} from '@mui/material';
import React, { FC, memo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { PopupComponent } from 'src/components/common/PopupComponent';
import { AppState, store, useAppSelector } from 'src/store';
import { setDocumentDetail } from 'src/store/documentDetail';
import { setSnackbarMessage } from 'src/store/snackbarMessage';
import DocManagementService from '../documentUpload/service/DocManagementService';

const MultiArtifactSendToIsfDialog: FC<any> = ({
  openLinkArtifactSendToISF,
  setOpenLinkArtifactSendToISF,
  setIsSentToIsf,
  taskId
}: any) => {
  const documentDetail: any = useSelector((state: AppState) => state.documentDetail);
  const docService = new DocManagementService();
  const user: any = useAppSelector(state => state.user.user);
  const userName = `${user.firstName + ' ' + user.lastName}`;
  const [isProcessing, setProcessing] = React.useState(false);
  const selectedStudy = useSelector((state: AppState) => state.searchHierarchyDetails?.data[0]?.Study);
  const selectedCountry = useSelector((state: AppState) => state.searchHierarchyDetails?.data[0]?.Country);
  const selectedSite = useSelector((state: AppState) => state.searchHierarchyDetails?.data[0]?.Site);
  const isfArtifacts = useAppSelector(state => state.MapIsfArtifacts.isfArtifacts);
  const [selectArtifact, setSelectArtifact] = useState<any>({});
  const dispatch = useDispatch();

  const handleCloseRejectDialog = () => {
    setOpenLinkArtifactSendToISF(false);
  };

  const handleConfirmClick = async () => {
    const Data = {
      action_name: 'Sent To ISF',
      sent_to_isf: true,
      is_resolved: false,
      updated_by: userName,
      isf_artifact_number: selectArtifact?.isf_artifact_number,
      isf_artifact_name: selectArtifact?.isf_artifact_name,
      isf_subtype: selectArtifact?.isf_subtype,
      isf_type: selectArtifact?.isf_type
    };
    setProcessing(true);
    const response = await docService.sendToISF(
      documentDetail.data[0].task_Id ? documentDetail.data[0].task_Id : taskId,
      Data,
      selectedStudy,
      selectedCountry,
      selectedSite,
      'Site',
      'DocumentApproval',
      documentDetail.data[0].tmf_document_name,
      false,
      true
    );
    if (response?.data) {
      setProcessing(false);
      setOpenLinkArtifactSendToISF(false);
      setIsSentToIsf(true);
      store.dispatch(setSnackbarMessage('Document sent to ISF successfully.', 'success'));
      setDocumentDetail(dispatch, [{ ...documentDetail.data[0], sent_to_isf: true }]);
    } else {
      setProcessing(false);
      setOpenLinkArtifactSendToISF(false);
      store.dispatch(setSnackbarMessage('Error in Sending To ISF.', 'error'));
    }
  };
  const handleChange = (e: any, values: any) => {
    setSelectArtifact({ ...values });
  };

  return (
    <React.Fragment>
      <PopupComponent
        open={openLinkArtifactSendToISF}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title" sx={{ fontWeight: 500 }}>
          Choose Artifact
        </DialogTitle>
        <DialogContent sx={{ maxWidth: 560 }}>
          {isProcessing && (
            <Box sx={{ width: '100%' }} mb={2}>
              <LinearProgress />
            </Box>
          )}
          <Typography
            variant="subtitle1"
            id="alert-dialog-description"
            mb={4}
            sx={{ color: 'rgba(0, 0, 0, 0.87)', fontSize: '15px' }}
          >
            The artifact associated with the document is mapped to more than one artifacts. Please select the right
            artifact before publishing it to ISF
          </Typography>
          <Autocomplete
            disabled={isProcessing}
            id="tags-standard-users"
            options={isfArtifacts ?? []}
            getOptionLabel={(option: any) => `${option.isf_artifact_name} (${option.isf_artifact_number})`}
            onChange={handleChange}
            renderInput={params => (
              <TextField {...params} variant="standard" label="Artifact" placeholder="Please Select an Artifact" />
            )}
          />
          <br />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseRejectDialog} className="grey-btn" disabled={isProcessing}>
            CANCEL
          </Button>
          <Button
            autoFocus
            onClick={handleConfirmClick}
            disabled={isProcessing || !selectArtifact?.isf_artifact_number}
          >
            SEND TO ISF
          </Button>
        </DialogActions>
      </PopupComponent>
    </React.Fragment>
  );
};

export default memo(MultiArtifactSendToIsfDialog);
